// Module
var code = "<imposition-preview-zoomin-directive layout-fill></imposition-preview-zoomin-directive>";
// Exports
module.exports = code;